import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";

const GridActions = ({ id, options, handleAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuEnabled, setMenuEnabled] = useState(true); // Nuevo estado para habilitar/deshabilitar el menú

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (e, name) => {
    if (menuEnabled) {
      handleAction(e, name, id);
      setMenuEnabled(false); // Deshabilitar el menú temporalmente
      handleClose(e);
      setTimeout(() => {
        setMenuEnabled(true); // Volver a habilitar el menú después de un breve retraso
      }, 300); // Ajusta este valor según sea necesario
    }
  };

  return (
    <React.Fragment>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        data-id={id}
        onClick={(e) => handleClick(e)}
        style={{ padding: "5px" }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={(e) => handleClose(e)}
        PaperProps={{
          style: {
            maxHeight: "auto",
            width: 250,
            padding: "5px",
          },
        }}
      >
        {options.map((val, idx) => (
          <MenuItem
            key={val.name}
            disabled={!menuEnabled}
            onClick={(e) => handleMenuItemClick(e, val.name)}
            style={{ fontSize: "0.875rem" }}
          >
            <a
              onClick={(e) => handleMenuItemClick(e, val.name)}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {val.name}
            </a>
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
};

export default GridActions;
